import { isIsoDate } from '../../validation/is-iso-date.function';
import { isIsoDateTime } from '../../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../../validation/is-iso-date-time-tz.function';
import { getTimeOffset } from '../../get/get-time-offset.function';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { constructDate } from '../../helper/construct-date.function';

/**
 * Returns the first instant of the year for a given ISO input.
 * - Date-only -> 'YYYY-01-01'
 * - Date-time (no tz) -> 'YYYY-01-01T00:00:00.000'
 * - Date-time with tz -> 'YYYY-01-01T00:00:00.000Z|±HH:MM'
 */
export function startOfYear<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'date' && deconstructed._type !== 'dateTime' && deconstructed._type !== 'dateTimeTz') {
    throw new Error('endOfYear: invalid ISO date/time string');
  }
  deconstructed.month = 1;
  deconstructed.day = 1;
  if (deconstructed._type !== 'date') {
    deconstructed.hours = 0;
    deconstructed.minutes = 0;
    deconstructed.seconds = 0;
    deconstructed.milliseconds = 0;
  }
  return constructDate(deconstructed) as unknown as T;
}
